// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';

// Import pages
import Home from './pages/Home';
import Research from './pages/Research';
import Tools from './pages/Tools';
import Publications from './pages/Publications';
import Team from './pages/Team';
import Contact from './pages/Contact';
import News from './pages/News';

// Create placeholder pages if they don't exist
const PlaceholderPage = ({ title }) => (
  <div style={{ paddingTop: '100px', textAlign: 'center' }}>
    <h1>{title} Page</h1>
    <p>This page is under construction.</p>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/research" element={<Research />} />
      <Route path="/tools" element={<PlaceholderPage title="Tools" />} />
      <Route path="/publications" element={<Publications/>} />
      <Route path="/team" element={<Team />} />
      <Route path="/contact" element={<Contact/>} />
      <Route path="/news" element={<News/>} />
    </Routes>
  </BrowserRouter>
);